$('body').on('click', '.photo .rotate-image-left-trigger', function () {
    var $this = $(this);
    var photo = $this.parents('.photo');
    
    loading('Rotating');
    $.ajax({
        type: 'POST',
        url: '/photo/' + photo.attr('data-photo') + '/rotate-left',
        data: {
            '_method': 'PUT',
            '_token': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();
            if (!data.success) {
                alert(data.message);
                return false;
            }

            photo.find('img').attr('src', data.image);
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
    return false;
});

$('body').on('click', '.photo .rotate-image-right-trigger', function () {
    var $this = $(this);
    var photo = $this.parents('.photo');

    $.ajax({
        type: 'POST',
        url: '/photo/' + photo.attr('data-photo') + '/rotate-right',
        data: {
            '_method': 'PUT',
            '_token': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();
            if (!data.success) {
              showNotice("Error", data.message, "Close");
              return false;
            }

            photo.find('img').attr('src', data.image);
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
    return false;
});

$('body').on('click', '.photo .delete-image-trigger', function () {
    var $this = $(this);
    var photo = $this.parents('.photo');

    loading('Deleting');
    $.ajax({
        type: 'POST',
        url: '/photo/' + photo.attr('data-photo'),
        data: {
            '_method': 'DELETE',
            '_token': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();
            if (!data.success) {
              showNotice("Error", data.message, "Close");
              return false;
            }

            photo.remove();
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
    return false;
});

$('body').on('keydown', '.photo .image-sort input', function (e) {
    if (e.keyCode != 13) {
        return;
    }

    var $this = $(this);
    var photo = $this.parents('.photo');

    loading();
    $.ajax({
        type: 'POST',
        url: '/photo/' + photo.attr('data-photo') + '/update-sort-order',
        data: {
            'sort_order': $this.val(),
            '_method': 'PUT',
            '_token': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();
            if (!data.success) {
                alert(data.message);
                return false;
            }

            $this.blur();
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
});

var photoShifting;
$(document).on('keyup keydown', function (e) { photoShifting = e.shiftKey; });


$('body').on('keydown', '.photo [name="caption"]', function (e) {
    if (e.keyCode != 13) {
        return;
    }

    if (photoShifting) {
        return;
    }

    e.preventDefault();
    var $this = $(this);
    var photo = $this.parents('.photo');
    
    loading();
    $.ajax({
        type: 'POST',
        url: '/photo/' + photo.attr('data-photo') + '/update-caption',
        data: {
            'caption': $this.val(),
            '_method': 'PUT',
            '_token': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();
            if (!data.success) {
                alert(data.message);
                return false;
            }

            $this.blur();
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
});